// extracted by mini-css-extract-plugin
export default {"submit-textarea":"UsupportedTypeModal_submit-textarea__MXm80","successModal":"UsupportedTypeModal_successModal__rC7aZ","success-title":"UsupportedTypeModal_success-title__WpP8Y"};